import Box from '@mui/material/Box';
import MuiButton from '@mui/material/Button';
import { Link } from 'react-router-dom';

import logo from 'assets/logo.svg';

import { colors } from 'styles';

import { HeaderStyled, HeaderNavigation } from './Header.style';
import { ContactUsButton, LogoLink } from './MobileHeader.style';

import { homeMeta, resourcesMeta } from 'constants/pages';
import { useContext } from 'react';
import { ScrollContext } from 'context/ScrollContext';
import { Dropdown } from './Dropdown';
import { industriesItems, applicationsItems, customerCasesItems, platformItems, actionPacksItems } from './constants';

const pagesWithoutBlurredHeader = ['/articles/', '/privacy-policy'];

type DesktopHeaderProps = { openModal: () => void };

export const DesktopHeader = ({ openModal }: DesktopHeaderProps) => {
  const isScrolled = useContext(ScrollContext);
  const isPageWithoutBlurredHeader = pagesWithoutBlurredHeader.some((path) =>
    location.pathname.includes(path),
  );
  const color = isScrolled || isPageWithoutBlurredHeader ? colors.darkGray : colors.white;
  const activeColor =
    isScrolled || isPageWithoutBlurredHeader
      ? 'rgba(52, 142, 233, 0.20)'
      : 'rgba(255, 255, 255, 0.2)';

  return (
    <HeaderStyled component="header" isScrolled={isScrolled || isPageWithoutBlurredHeader}>
      <HeaderNavigation component="nav">
        <Box mr="auto">
          <LogoLink to={homeMeta.url}>
            <img src={logo} alt="logo icon" />
          </LogoLink>
        </Box>

        <Box width="100%" justifyContent="center" alignItems="center" display="flex">
          <Dropdown
            isScrolled={isScrolled}
            label="Get Started!"
            items={actionPacksItems}
            color={color}
            isActive={location.pathname.startsWith('/action-packs')}
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Dropdown
            isScrolled={isScrolled}
            label="Platform"
            items={platformItems}
            color={color}
            isActive={location.pathname.startsWith('/platform')}
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Dropdown
            isScrolled={isScrolled}
            label="Industries"
            items={industriesItems}
            color={color}
            isActive={
              location.pathname.startsWith('/Industries') || location.pathname === '/all-industries'
            }
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Dropdown
            isScrolled={isScrolled}
            label="Applications"
            items={applicationsItems}
            color={color}
            isActive={
              location.pathname.startsWith('/applications') ||
              location.pathname === '/all-applications'
            }
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Dropdown
            isScrolled={isScrolled}
            label="Customer Cases"
            items={customerCasesItems}
            color={color}
            isActive={
              location.pathname.startsWith('/customer-case') ||
              location.pathname === '/all-customer-cases'
            }
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          {/* <Dropdown
            isScrolled={isScrolled}
            label="Company"
            items={companyItems}
            color={color}
            isActive={location.pathname.startsWith('/company')}
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          /> */}

          <Box mr={1}>
            <MuiButton
              component={Link}
              to={resourcesMeta.url}
              sx={{
                color,
                fontSize: '16px',
                fontWeight: 500,
                textTransform: 'capitalize',
                lineHeight: '22px',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: isScrolled ? 'rgba(34, 34, 34, 0.8)' : colors.blue,
                },
                padding: '8px',
                background:
                  location.pathname.startsWith('/resources') && activeColor
                    ? `${activeColor}!important`
                    : 'transparent',
              }}
            >
              Resources
            </MuiButton>
          </Box>
        </Box>

        <ContactUsButton
          onClick={openModal}
          color="secondary"
          variant={isScrolled ? 'outlined' : 'contained'}
          style={{ width: '120px', height: '50px', fontSize: '14px' }}
        >
          Contact us
        </ContactUsButton>
      </HeaderNavigation>
    </HeaderStyled>
  );
};
